import {BarcodeListener, BarcodeReader} from "@variocube/app-api";
import {BarcodeReaderMessageTypes, BarcodeScanned} from "@variocube/driver-common";
import {VcmpClient} from "@variocube/vcmp";
import {isThisUnit} from "./unit";

export class ControllerBarcodeReader implements BarcodeReader {

    private barcodeListeners = new Set<BarcodeListener>();

    constructor(url: string) {
        const client = new VcmpClient(url);
        client.on(BarcodeReaderMessageTypes.BarcodeScanned, this.handleBarcodeScanned);
        client.start();
    }

    addBarcodeListener(listener: BarcodeListener) {
        this.barcodeListeners.add(listener);
    }

    removeBarcodeListener(listener: BarcodeListener) {
        this.barcodeListeners.delete(listener);
    }

    private handleBarcodeScanned = ({code, unit}: BarcodeScanned) => {
        console.info("Barcode scanned: ", {code, unit});
        if (isThisUnit(unit)) {
            this.barcodeListeners.forEach(listener => listener({code}));
        }
        else {
            console.info("Ignoring barcode from another unit");
        }
    };

}
